module.exports = __webpack_public_path__ + "img/distence2.834bcfa.webp";